import React, { memo, useRef } from "react";

import Image from "../../components/Image";
import Icon from "../../components/Icon";
import Link from "../../components/Link";
import DashedLineImages from "../../components/HeroBanner/DashedLineImages";
import TransparentVideo from "../../components/TransparentVideo/TransparentVideo";

import { vendorData, vendorListItems } from "../../constants/vendor-payments";
import {
  INTERNATIONAL_WIRE_TRANSFER,
  WEBSITE_ASSETS_URL,
} from "../../constants/Url";
import { MERCHANT_DASHBOARD_SIGNUP_URL } from "../../constants/env";

import "../../styles/global-payments.scss";

const HeroSection = () => {
  const vendorAni = useRef();

  const animationData = `${WEBSITE_ASSETS_URL}/vendor-payments-hero/vendor-payments.webm`;

  return (
    <section className="pt-[110px] lg:pt-[50px] pb-[0px] md:pb-[64px] md:pb-[20px] text-white overflow-hidden relative lg:max-h-[944px] vendor-payments-bg">
      <div className="container">
        <div className="flex flex-wrap flex-col lg:flex-row lg:flex-nowrap w-full lg:w-[120%] custom-margin-hero-section">
          {" "}
          <div className="relative z-[1] w-full lg:w-[40%] lg:self-center">
            <h1 className="text-sm font-semibold text-white pl-5 mb-[10px] uppercase relative before:bg-cf-green before:h-[10px] before:w-[10px] before:absolute before:top-[4px] before:left-[4px] font-body">
              VENDOR PAYMENTS
            </h1>
            <div className="mb-5 text-[28px] md:text-[40px] font-semibold max-w-[576px] font-heading leading-[40px] md:leading-[48px]">
              Upload, approve, and&nbsp;
              <h2 className="inline mb-5 text-[28px] md:text-[40px] font-semibold font-heading leading-[40px] md:leading-[48px]">
                pay invoices
              </h2>{" "}
              on a single platform
            </div>
            <div className="mb-8 max-w-[580px] text-[16px] md:text-[18px] leading-[24px]">
              Manage all your{" "}
              <h2 className="inline text-[16px] md:text-[18px] font-normal font-body">
                account payables
              </h2>{" "}
              effortlessly on a single platform. Upload invoices, sync with
              Tally, customise approval workflows, pay, and reconcile easily
              using invoice reports.
            </div>
            <ul className="p-0 mt-[24px] md:mt-[28px] mb-4 md:mb-[48px] list-none max-w-full flex flex-wrap flex-row md:items-center justify-start">
              {vendorListItems.map((listItem) => (
                <li
                  key={listItem}
                  className="mb-[15px] items-center md:mb-0 mr-[24px] lg:mr-4 xl:mr-[24px] last:mr-0 flex">
                  <span className="w-5 h-5 flex flex-none justify-center items-center rounded-full mr-2 bg-white  bg-opacity-25">
                    <Icon
                      name="tick"
                      width="9.21px"
                      height="6.29px"
                      fill="#fff"
                    />
                  </span>
                  <h3 className="font-body !m-0 text-2.5sm md:text-md font-normal">
                    <div>{listItem}</div>
                  </h3>
                </li>
              ))}
            </ul>
            <Link
              className="button button-green w-full md:w-auto mr-[0px] md:mr-[20px]"
              to={`${MERCHANT_DASHBOARD_SIGNUP_URL}?source-action=Vendor%20Payments&action=Sign%20Up&button-id=StartNow_Hero`}>
              Create Account <span className="chevron" />
            </Link>
            <a
              className="button button-outline text-[#fff] no-shadow w-full md:w-auto mt-4 md:mt-0"
              href="https://form.typeform.com/to/AvZfYTFL"
              target="_blank"
              rel="noreferrer">
              Book Demo <span className="chevron" />
            </a>
          </div>
          <div className="w-full lg:w-[47%] lg:pl-[25px] lg:pt-[0] pt-[20px] flex justify-center h-full items-center">
            <TransparentVideo
              backgroundRef={vendorAni}
              className="relative z-10 rounded-lg"
              mp4Src={animationData}
              webmSrc={animationData}
              preload="auto"
              width="1499"
              height="850"
            />
          </div>
        </div>

        <DashedLineImages
          desktopSrc={`${INTERNATIONAL_WIRE_TRANSFER}/DesktopDashedLine.png`}
          mobileSrc={`${INTERNATIONAL_WIRE_TRANSFER}/MobileDashedLine.png`}
        />

        <div className="banner-icon-section">
          <div className="text-center block font-semibold text-[18px] md:text-[20px] mb-[30px] mt-[50px]">
            One-stop{" "}
            <h2 className="text-[18px] md:text-[20px] inline font-body font-semibold">
              Vendor Payments Platform
            </h2>
          </div>
          <div className="flex md:flex-row flex-col justify-evenly">
            {vendorData.map(({ src, alt, text }) => (
              <div key={src} className="flex align-center mb-[20px]">
                <Image
                  src={src}
                  alt={alt}
                  className="mr-[15px] w-[40px] h-[40px] md:w-[60px] md:h-[60px]"
                  width="60"
                  height="60"
                />
                <div>
                  <p className="text-[#DFD7F4] md:text-[#fff] text-[14px] md:text-[15px]">
                    {text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(HeroSection);
